import React from 'react';
import MainNav from './MainNav';
import TopNav from './TopNav';

const Header = () => (
  <div>
    <TopNav />
    <MainNav />
  </div>
);

export default Header;
